import React from "react";
import imgData from "../../assets/products/Teasury.png";
import { CustomButton } from "../CustomButton/CustomButton";
import { useLanguage } from "../../i18n/LanguageContext";

const Treasury = () => {
  const { t } = useLanguage();

  return (
    <div className="mt-[65px] lg:mt-[80px] min-h-screen pb-20 md:pb-0 bg-white">
      <div className="mx-auto sm:max-w-3xl lg:max-w-screen-2xl 2xl:max-w-screen-2xl px-5 md:px-8">
        <div className="overflow-hidden rounded-2xl shadow-lg shadow-blue/10 mt-4">
          <img
            alt="Treasury"
            className="w-full h-full lg:h-96 object-cover object-top transition-transform duration-500 hover:scale-[1.02]"
            src={imgData}
          />
        </div>

        <div className="mt-8 lg:mt-12">
          <p className="text-sm font-semibold uppercase tracking-widest text-orange mb-2">
            {t("common.product")}
          </p>
          <h3 className="text-3xl lg:text-4xl font-bold text-blue">
            {t("products.treasury.title")}
          </h3>
          <h4 className="text-xl md:text-2xl text-orange font-semibold mt-2">
            {t("products.treasury.subtitle")}
          </h4>
          <div className="mt-4 w-16 h-1 rounded-full bg-gradient-to-r from-orange to-pink" />
        </div>

        <div className="mt-8 max-w-4xl space-y-6 text-base md:text-lg text-darkBlue/70 leading-relaxed">
          <p>{t("products.treasury.p1")}</p>
          <p>{t("products.treasury.p2")}</p>
        </div>

        <div className="mt-12 mb-10">
          <CustomButton
            text={`${t("common.talkToExpert")} ->`}
            color="text-white px-8"
            borderColor="border-orange"
            fill="bg-orange hover:bg-pink"
            padding="py-3 px-6"
            href="/contact"
          />
        </div>
      </div>
    </div>
  );
};

export default Treasury;
